import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { valdiatePage } from "../../global";
import { setLoading } from "../../redux/appSlice";
import { getAccountServices, getAllServices, saveService } from "../../services/userservice";

const ServiceRequest = () => {

    const dispatch = useDispatch();
    const { userInfo, accounts } = useSelector(state => state.appData);

    const history = useHistory();

    const d = {
        accountNo: '',
        service: ''
    }

    const [data, setData] = useState(d);
    const [accountServices, setAccountServices] = useState([]);
    const [services, setServices] = useState([]);

    useEffect(() => {
        if (valdiatePage('/servicerequest')) {
            const loaddata = async () => {
                dispatch(setLoading({ data: true }));
                const rs = await getAllServices();
                const accrs = await getAccountServices(accounts);
                dispatch(setLoading({ data: false }));

                if (rs.ok) {
                    setServices(rs.data)
                } else {
                    alert(rs.msg);
                }

                if (accrs.ok) {
                    setAccountServices(accrs.data)
                } else {
                    alert(accrs.msg);
                }
            }
            loaddata();
        } else {
            history.push('/login');
        }
    }, []);

    const updateData = (key, val) => setData(prev => { return { ...prev, [key]: val } });

    const updateServices = (index, key, val) => {
        const s = [...services];
        s[index][key] = val;
        setServices(s);
    }

    const onSave = async () => {
        if (!data.accountNo) {
            alert('Select Account');
            return;
        }
        if (!data.service) {
            alert('Select Service');
            return;
        }

        if (accountServices.some(x => x.Account == data.accountNo && x.Service == data.service)) {
            alert('Service already active');
            return;
        }

        dispatch(setLoading({ data: true }));
        const rs = await saveService(data);
        dispatch(setLoading({ data: false }));

        alert(rs.msg);

        if (rs.ok) {
            setData(d);
            const accrs = await getAccountServices(accounts);
            if (accrs.ok) {
                setAccountServices(accrs.data)
            } else {
                alert(accrs.msg);
            }
        }
    }

    return userInfo && <section className="section">
        <div className="section-header">
            <h1>Service Request</h1>
        </div>
        <div className="card" style={{ padding: 10 }}>
            <div className="row">
                <div className="col-lg-3 col-sm-12">
                    <label>Account</label>
                    <select className="form-select" value={data.accountNo} onChange={e => updateData('accountNo', e.target.value)}>
                        <option value="">Select Account</option>
                        {
                            accounts.map((x, index) => <option key={index} value={x}>{x}</option>)
                        }
                    </select>
                </div>
                <div className="col-lg-3 col-sm-12">
                    <label>Services</label>
                    <select className="form-select" value={data.service} onChange={e => updateData('service', e.target.value)}>
                        <option value="">Select Service</option>
                        {
                            services.map((x, index) => <option key={index} value={x} >{x}</option>)
                        }
                    </select>
                </div>
            </div>
            <div className="row mt-3">
                <div className="col" style={{ textAlign: 'right' }}>
                    <button type="button" className="btn btn-primary" onClick={onSave}>Save</button>
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-12">
                    <h4 className="text-center">Active Services</h4>
                    <div className="table-responsive">
                        <table className="table table-bordered w-100">
                            <thead>
                                <tr>
                                    <th>Account</th>
                                    <th>Service</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    accountServices.map((x, index) =>
                                        <tr key={index}>
                                            <td>{x.Account}</td>
                                            <td>{x.Service}</td>
                                        </tr>)
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </section>
}

export default ServiceRequest;